import * as React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { OverlayContainer, Button } from 'components';

import './style.scss';

export interface IOverlayMessageProps {
    className?: string;
    messageText: string;
    closeButtonText?: string;
    onCloseButtonClick: () => void;
}

export const OverlayMessage = (props: IOverlayMessageProps) => {
    const { t } = useTranslation();
    let closeButtonText: string = props.closeButtonText || t('Закрыть');

    return (
        <OverlayContainer
            className={clsx('overlay-message', props.className)}
            containerClassname='form-wrapper'
            backgroundOpacity={8}
        >
            <div className="form">
                <div className="form-header">
                    {props.messageText}
                </div>
                <div className="form-body">
                    <Button
                        text={closeButtonText}
                        onClick={props.onCloseButtonClick}
                    />
                </div>
            </div>
        </OverlayContainer>
    );
};
